"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LimitOrderProtocolMethods = exports.InteractionsFields = exports.ChainId = void 0;
var ChainId;
(function (ChainId) {
    ChainId[ChainId["etherumMainnet"] = 1] = "etherumMainnet";
    ChainId[ChainId["binanceMainnet"] = 56] = "binanceMainnet";
    ChainId[ChainId["polygonMainnet"] = 137] = "polygonMainnet";
    ChainId[ChainId["optimismMainnet"] = 10] = "optimismMainnet";
    ChainId[ChainId["arbitrumMainnet"] = 42161] = "arbitrumMainnet";
    ChainId[ChainId["gnosisMainnet"] = 100] = "gnosisMainnet";
    ChainId[ChainId["avalancheMainnet"] = 43114] = "avalancheMainnet";
    ChainId[ChainId["fantomMainnet"] = 250] = "fantomMainnet";
    ChainId[ChainId["auroraMainnet"] = 1313161554] = "auroraMainnet";
    ChainId[ChainId["klaytnMainnet"] = 8217] = "klaytnMainnet";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
exports.InteractionsFields = {
    makerAssetData: 0,
    takerAssetData: 1,
    getMakingAmount: 2,
    getTakingAmount: 3,
    predicate: 4,
    permit: 5,
    preInteraction: 6,
    postInteraction: 7,
    // cuz enum has numeric keys also
};
var LimitOrderProtocolMethods;
(function (LimitOrderProtocolMethods) {
    LimitOrderProtocolMethods["getMakingAmount"] = "getMakingAmount";
    LimitOrderProtocolMethods["getTakingAmount"] = "getTakingAmount";
    LimitOrderProtocolMethods["arbitraryStaticCall"] = "arbitraryStaticCall";
    LimitOrderProtocolMethods["fillOrder"] = "fillOrder";
    LimitOrderProtocolMethods["fillOrderToWithPermit"] = "fillOrderToWithPermit";
    LimitOrderProtocolMethods["fillOrderRFQ"] = "fillOrderRFQ";
    LimitOrderProtocolMethods["cancelOrder"] = "cancelOrder";
    LimitOrderProtocolMethods["cancelOrderRFQ"] = "cancelOrderRFQ";
    LimitOrderProtocolMethods["nonce"] = "nonce";
    LimitOrderProtocolMethods["advanceNonce"] = "advanceNonce";
    LimitOrderProtocolMethods["increaseNonce"] = "increaseNonce";
    LimitOrderProtocolMethods["and"] = "and";
    LimitOrderProtocolMethods["or"] = "or";
    LimitOrderProtocolMethods["eq"] = "eq";
    LimitOrderProtocolMethods["lt"] = "lt";
    LimitOrderProtocolMethods["gt"] = "gt";
    LimitOrderProtocolMethods["timestampBelow"] = "timestampBelow";
    LimitOrderProtocolMethods["timestampBelowAndNonceEquals"] = "timestampBelowAndNonceEquals";
    LimitOrderProtocolMethods["nonceEquals"] = "nonceEquals";
    LimitOrderProtocolMethods["remaining"] = "remaining";
    LimitOrderProtocolMethods["transferFrom"] = "transferFrom";
    LimitOrderProtocolMethods["checkPredicate"] = "checkPredicate";
    LimitOrderProtocolMethods["remainingsRaw"] = "remainingsRaw";
    LimitOrderProtocolMethods["simulate"] = "simulate";
})(LimitOrderProtocolMethods = exports.LimitOrderProtocolMethods || (exports.LimitOrderProtocolMethods = {}));
//# sourceMappingURL=limit-order-protocol.model.js.map